<ub-card [rounded]="true">
  <h1 title i18n>My bookings</h1>
  <div content>
    <eas-interactive-table [options]="tableComponentOptions"></eas-interactive-table>
  </div>
</ub-card>
